<div
  [formGroup]="formGroup"
  *transloco="let t; read 'prices.upsert_price';">


  <div class="flex gap-4 items-center" *transloco="let g; read 'prices';">
    <div class="text-xl font-bold my-4">
      {{ t('two_tariff') }}:
    </div>
    <psc-switch
      formControlName="twoTariff"
      [checkedLabel]="g('true')"
      [uncheckedLabel]="g('false')"></psc-switch>
  </div>
  <div class="flex gap-10 mb-4" *ngIf="twoTariff" @inOutAnimation>
    <div>
      <div class="text-2xl font-bold">
        {{ t('pricing_list') }}
      </div>
      <div class="text-sm">
        ({{ t('at_least_one') }})
      </div>
    </div>

    <psc-button
      size="small"
      type="secondary-yellow"
      (buttonClicked)="addPricing()">
      <div class="flex gap-2 items-center justify-center">
        {{ t('add_new_pricing') }}
        <mat-icon>add</mat-icon>
      </div>
    </psc-button>
  </div>

  <!--  Pricing list  -->
  <div formArrayName="pricingList" class="flex flex-col gap-8 items-center" *ngIf="twoTariff && pricingList"
       @inOutAnimation>
    <div class="border border-blue1 rounded p-4 w-fit" *ngFor="let price of pricingList.controls; let i = index"
         [formGroupName]="i"
         @inOutAnimation>
      <div class="flex gap-10 relative">
        <div class="flex-1">
          <div class="text-xl font-bold mb-2">
            {{ t('date_from') }}
          </div>
          <psc-price-date-picker
            [dateForm]="dateFrom(i)"></psc-price-date-picker>
        </div>
        <div class="relative hidden md:block">
          <div class="absolute bottom-[30px] text-4xl font-bold ">
            -
          </div>
        </div>
        <div class="flex-1">
          <div class="text-xl font-bold mb-2">
            {{ t('date_to') }}
          </div>
          <psc-price-date-picker
            [dateForm]="dateTo(i)"></psc-price-date-picker>
        </div>
        <div class="absolute top-0.5 right-0.5">
          <psc-button
            type="secondary-magenta"
            [label]="t('remove_pricing')"
            size="tiny"
            (buttonClicked)="removePricing(i)"></psc-button>
        </div>
      </div>

      <!--  Timeslots list  -->
      <h3 class="py-4">{{ t('times') }}:</h3>
      <div formArrayName="timeSlots">
        <ng-container *ngFor="let timeSlot of timeSlots(i).controls; let j = index" [formGroupName]="j">
          <div
            [ngClass]="{'border-sun-yellow border-t': j > 0}"
            class="flex flex-col md:flex-row md:border-none relative gap-5 py-5 md:py-1"
            @inOutAnimation>
            <div class="grid grid-cols-2 gap-3 items-end">
              <psc-select
                [options]="timeOptions"
                formControlName="timeFrom"
                [label]="t('timeFrom')"></psc-select>
              <psc-select
                [options]="timeOptions"
                formControlName="timeTo"
                [label]="t('timeTo')"></psc-select>
            </div>

            <div class="md:border w-[1px] h-[75px] after:content-[''] hidden md:block self-center"></div>

            <div class="flex gap-4 items-center" *transloco="let g; read 'prices';">
              <div>
                {{ t('high_tariff') }}:
              </div>
              <psc-switch
                formControlName="highTariff"
                [checkedLabel]="g('true')"
                [uncheckedLabel]="g('false')"></psc-switch>
            </div>

            <div
              class="cursor-pointer hover:opacity-80 absolute md:relative top-5 md:top-auto right-5 md:right-auto self-center"
              [ngClass]="{'invisible pointer-events-none': j === 0}"
              (click)="removeTimeslot(i, j)">
              <mat-icon class="text-magenta">delete</mat-icon>
            </div>

          </div>
        </ng-container>
      </div>

      <div class="flex justify-end">
        <psc-button
          size="small"
          type="secondary-blue"
          (buttonClicked)="addTimeSlot(i)">
          <div class="flex gap-2 items-center justify-center">
            <mat-icon>add</mat-icon>
          </div>
        </psc-button>
      </div>
    </div>
  </div>
  <!--  Block tariff list  -->
  <h3 class="py-4">{{ t('block_tariffs') }}:</h3>
  <div formArrayName="blockList">
    <ng-container *ngFor="let block of blockList.controls; let i = index; let last = last" [formGroupName]="i">
      <div
        [ngClass]="{'border-sun-yellow border-t': i > 0}"
        class="flex flex-col relative gap-3 py-5"
        @inOutAnimation>
        <div class="flex justify-between">
          <div class="flex gap-3">
            <psc-input
              type="number"
              [isDisabled]="true"
              formControlName="rangeStart"
              [label]="t('rangeStart')">
            </psc-input>
            <psc-input
              type="number"
              [isDisabled]="!last"
              formControlName="range"
              [label]="t('range')"></psc-input>
          </div>

          <div class="cursor-pointer hover:opacity-80 self-center"
               [ngClass]="{'invisible pointer-events-none': i === 0}"
               (click)="removeBlock(i)">
            <mat-icon class="text-magenta">delete</mat-icon>
          </div>
        </div>

        <div class="grid grid-cols-4 gap-3 items-end">
          <psc-input
            formControlName="priceKWH_H"
            type="number"
            [label]="twoTariff ? t('priceKWH_H') : t('priceKWH')"></psc-input>
          <psc-input
            formControlName="priceDistribution_H"
            type="number"
            [label]="twoTariff ? t('priceDistribution_H') : t('priceDistribution')"></psc-input>
          <psc-input
            formControlName="priceTransfer_H"
            type="number"
            [label]="twoTariff ? t('priceTransfer_H') : t('priceTransfer')"></psc-input>
          <psc-input
            [ngClass]="{'self-center row-span-2': twoTariff}"
            formControlName="priceOIE"
            type="number"
            [label]="t('priceOIE')"></psc-input>

          <ng-container *ngIf="twoTariff">
            <psc-input
              formControlName="priceKWH_L"
              type="number"
              [label]="t('priceKWH_L')"></psc-input>
            <psc-input
              formControlName="priceDistribution_L"
              type="number"
              [label]="t('priceDistribution_L')"></psc-input>
            <psc-input
              formControlName="priceTransfer_L"
              type="number"
              [label]="t('priceTransfer_L')"></psc-input>
          </ng-container>
        </div>

      </div>
    </ng-container>


    <div class="flex justify-end">
      <psc-button
        size="small"
        type="secondary-blue"
        [disabled]="blockList && blockList.length > 0 && !blockListElement(this.blockList.length - 1).controls?.['range']?.value"
        (buttonClicked)="addBlock()">
        <div class="flex gap-2 items-center justify-center">
          <mat-icon>add</mat-icon>
        </div>
      </psc-button>
    </div>
  </div>
</div>
